export default __webpack_public_path__ + "static/media/bar-main_pc@2x.00c1ba57.png";